import { createRouter, createWebHistory } from "vue-router";
import RootView from "@/views/RootView.vue";
import authRoutes from "@/views/auth/authRoutes";
import residentsRoutes from "@/views/residents/residentsRoutes";
import companiesRoutes from "@/views/companies/companiesRoutes";
import { ifAuthenticated } from "@/helpers/routerHelpers";

const routes = [
  ...authRoutes,
  ...residentsRoutes,
  ...companiesRoutes,
  {
    path: "/",
    name: "Root",
    component: RootView,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/profile",
    name: "ProfilePage",
    component: () =>
      import(/* webpackChunkName: "ProfilePage" */ "@/views/ProfilePage.vue"),
    meta: {
      layout: "main",
    },
    beforeEnter: ifAuthenticated,
  },
  // Page for 404 error
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "notFound" */ "@/views/404.vue"),
    meta: {
      layout: "auth",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

export default router;
